import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {InputNumber} from 'antd';

const TemplateRegisterOrder = ({initialValue, onChange, ...props}) => {
  return (
    <div className='flex justify-start items-center w-full min-w-48'>
      <InputNumber
        min={1}
        max={initialValue}
        defaultValue={initialValue}
        onChange={onChange}
        {...props}
      />
    </div>
  );
};

TemplateRegisterOrder.propTypes = {
  initialValue: PropTypes.number,
  onChange: PropTypes.func,
};

TemplateRegisterOrder.defaultProps = {
  value: null
};

export default memo(TemplateRegisterOrder);
